import React from 'react';

interface ContentSectionProps {
    children: React.ReactNode;
    maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '4xl' | '5xl' | '6xl' | '7xl';
    padding?: 'sm' | 'md' | 'lg' | 'xl';
    className?: string;
    centered?: boolean;
}

const ContentSection: React.FC<ContentSectionProps> = ({
    children,
    maxWidth = '4xl',
    padding = 'lg',
    className = '',
    centered = false
}) => {
    const paddingClasses = {
        sm: 'py-12',
        md: 'py-16',
        lg: 'py-20',
        xl: 'py-24'
    };

    const maxWidthClasses = {
        sm: 'max-w-sm',
        md: 'max-w-md',
        lg: 'max-w-lg',
        xl: 'max-w-xl',
        '2xl': 'max-w-2xl',
        '4xl': 'max-w-4xl',
        '5xl': 'max-w-5xl',
        '6xl': 'max-w-6xl',
        '7xl': 'max-w-7xl'
    };

    return (
        <section className={`${paddingClasses[padding]} ${className}`}>
            <div className={`${maxWidthClasses[maxWidth]} mx-auto px-6 ${centered ? 'text-center' : ''}`}>
                {children}
            </div>
        </section>
    );
};

export default ContentSection;
